export default __webpack_public_path__ + "static/media/loading.595450f4.gif";